<template>
  <div class="App">
    <router-view></router-view>
    <Header />
    <notifications
      position="bottom right"
      width="auto"
      classes="notification"
    />
  </div>
</template>


<script>
import Header from '@/Components/Header';

export default {
  name: 'App',
  components: {
    Header,
  },
};
</script>

<style>
#app {
  font-family: "Montserrat", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body {
  background-color: rgb(250, 250, 240);
  margin: 80px 0 0 0;
}
html {
  scroll-behavior: smooth;
}

.Undertitle {
  font-style: oblique;
  margin-bottom: 50px;
}
.Text {
  text-align: left;
}
.SectionHeader h1 {
  color: white;
  text-align: center;
  padding-top: 200px;
  font-size: 100px;
  font-weight: 200;
  letter-spacing: 40px;
  text-shadow: 0px 3px 3px black;
}
h1.Header {
  color: white;
  background-color: black;
  text-align: center;
  font-size: min(6vw, 72px);
  font-weight: 100;
  letter-spacing: 40px;
  padding-top: 50px;
  padding-bottom: 50px;
}

.SectionHeader {
  min-height: 600px;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
img.Paragraph {
  width: 400px;
  height: 600px;
  margin: 5vh;
  object-fit: cover;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.4);
}

button {
  color: #5a5a5a;
  font: inherit;
  background: none;
  border: solid 2px #474544;
  color: #474544;
  cursor: pointer;
  display: inline-block;
  font-family: "Helvetica", Arial, sans-serif;
  font-size: 0.875em;
  font-weight: bold;
  outline: none;
  padding: 20px 35px;
  text-transform: uppercase;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

button:hover {
  background: #474544;
  color: #f2f3eb;
}

.buttonWrapper {
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.shadow {
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.4);
}

.notification {
  margin: 0 10px 10px 0;
  padding: 16px;
  font-size: 16px;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);

  background: black;
  border-left: 15px solid #ffffff;
}
.notification.success {
  color: white;
  background: rgb(32, 32, 32);
  border-left-color: #42a85f;
}

.notification.warn {
  color: white;
  background: #ffb648;
  border-left-color: #f48a06;
}

.notification.error {
  color: white;
  background: #e54d42;
  border-left-color: #b82e24;
}
.notification h1 {
  font-weight: 700;
  font-size: 20px;
  margin: 0;
}
.notification p {
  font-size: 18px;
  font-style: italic;
  margin: 10px 0 0 0;
}
.before-enter {
  opacity: 0;
  transform: translateY(100px);
  transition: all 1s ease-out;
}
.enter {
  opacity: 1;
  transform: translateY(0px);
}
input,
select,
textarea {
  background: none;
  border: none;
  border-bottom: solid 2px #474544;
  color: #474544;
  font-size: 1em;
  font-weight: 400;
  letter-spacing: 1px;
  margin: 0em 0 1.875em 0;
  padding: 0 0 0.875em 0;
  text-transform: uppercase;
  width: 100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

input:focus,
textarea:focus {
  outline: none;
  padding: 0 0 0.875em 0;
}
</style>
